import { inject } from '@angular/core'
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router'
import { MatchService } from './service'

export const matchResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const ms = inject(MatchService)
  ms.matchId.set(route.paramMap.get('matchId') ?? '')
  return true
}
